/*
 * Module for the DROP Age Alerts Letters job criteria page
 */
rs.module("content/jobs/criteria/dropagealertsletters",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(
            jsSelectors,
            printers,
            preferredPrinter) {

            var criteria = $.js(jsSelectors.criteria);

            var dropPlanSelect = criteria.js(jsSelectors.dropPlanSelect, { required: false });
            var dropPlanNameHidden = criteria.js(jsSelectors.dropPlanNameHidden);
            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var printersSelect = criteria.js(jsSelectors.printersSelect);

            // Get Select Helper for Select Lists since we're updating their options and properties
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // On Drop Plan value change, store text in Hidden Field (dropPlanName) needed for job criteria
            dropPlanSelect.change(function () {
                dropPlanNameHidden.val(dropPlanSelect.find(":selected").text());
            });

            // Register skipReviewCheckBox change event to enable/disable appropriate fields
            skipReviewCheckBox.change(enableDisableSkipReviewFields);

            // On page initialize, enable/disable the Printer Select drop down
            $(enableDisableSkipReviewFields);

            // On page initialize, store DROP Plan Name in Hidden Field based on current value
            dropPlanNameHidden.val(dropPlanSelect.find(":selected").text());

            // Enable or disable Skip Review fields
            function enableDisableSkipReviewFields() {
                if (skipReviewCheckBox.is(":checked")) {

                    // enable and re-populate printer select
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(printers);

                    // Since we have reloaded printers, we should again default to the user's preferred printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    // disable and clear the printer list
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);